import React, { Component } from "react";
import Btn from "../../../Components/Btn";
import BookingPopup from "../../Bookings/Components/BookingPopup";
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { getStatus } from "../../../config";
import { numberWithCommas } from "../../../helpers/formatters";

class RecentBookings extends Component {
    constructor(props) {
      super(props);
      this.state = {
        popupActive: null,
      };
    }

    //In case API sends code
    getStatus(statusCode) {
        switch (statusCode) {
            case 1:
                return "confirmed";
            case 2:
                return "pending";
            case 3:
                return "canceled";
            default:
                return statusCode;
        }
    }
    getType(typeCode) {
        switch (typeCode) {
            case 1:
                return "One Way";
            case 2:
                return "Two Way";
            default:
                return typeCode;
        }
    }
    formatDate(string) {
        var options = { year: 'numeric', month: 'short', day: '2-digit' };
        return new Date(string).toLocaleDateString([], options);
    }
    togglePopupClasses = (event, id) => {
      event.preventDefault();
      this.setState({ popupActive: this.state.popupActive !== id ? id : null });
    };
    render() {
        let bookings = [];
        let bookingsData = this.props.tickets
        bookingsData.forEach((booking, i) => {
            if(i > 4) return;
            bookings.push(
                <tr key={booking.CardID}>
                    <td>
                        {booking.CardID}
                        <br />
                        <span className={`booking-status ${getStatus(booking.CardStatusID)}`}>{getStatus(booking.CardStatusID)}</span>
                    </td>
                    <td>{decodeURI(booking.UserName)}</td>
                    <td>{booking.myTrips[0].TripOfficeFrom} - {booking.myTrips[0].TripOfficeTo}</td>
                    <td>
                        <div className="price-details">
                            <h4><strong className="bolder">{numberWithCommas(booking.CardTotalPrice)} EGP</strong></h4>
                            <p>{booking.TripServKind}</p>
                        </div>
                    </td>
                    <td>
                        <Btn 
                        className="btn simple"
                        onClick={event => this.togglePopupClasses(event, booking.CardID)}
                        >
                            view
                        </Btn>
                    </td>
                </tr>
            );
        });
        return (
            <div className="table-responsive">
                <table>
                    <tbody>
                        <tr>
                            <th>Booking ID.</th>
                            <th>Traveler Name</th>
                            <th>Route</th>
                            <th>Price / Class</th>
                            <th></th>
                        </tr>
                        {bookings}
                    </tbody>
                </table>
                <BookingPopup currentBooking={this.state.popupActive} bookingsData={bookingsData} toggleFn={this.togglePopupClasses} />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    tickets: state.tickets.tickets,
})


export default connect(mapStateToProps)(withRouter(RecentBookings));